import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import MobileMenu from '../components/MobileMenu';
import ServicesSection from '../components/ServicesSection';
import heroBg from '../assets/hero-bg.jpg';

function Prestations() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    document.body.classList.toggle('mobile-menu-open', mobileOpen);
  }, [mobileOpen]);

  return (
    <div className='App' style={{ background: 'url(' + heroBg + ') left top / cover fixed no-repeat', minHeight: '100vh', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
      <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} />
      {mobileOpen && <MobileMenu onClose={() => setMobileOpen(false)} />}
      <ServicesSection />
      <Footer />
      <BackToTop />
    </div>
  );
}

export default Prestations;
